/**
 * Constants for Racking Inspection Screen
 * Contains filter options, table columns and other static data
 */

import { FilterItem } from "../../types/observation";

/**
 * Filter options for Walk Observations tab
 */
export const WALK_OBSERVATIONS_FILTER_OPTIONS: FilterItem[] = [
  {
    key: "period",
    label: "Period",
    options: [
      { id: "1", displayText: "P1" },
      { id: "2", displayText: "P2" },
      { id: "3", displayText: "P3" },
      { id: "4", displayText: "P4" },
      { id: "5", displayText: "P5" },
      { id: "6", displayText: "P6" },
      { id: "7", displayText: "P7" },
      { id: "8", displayText: "P8" },
      { id: "9", displayText: "P9" },
      { id: "10", displayText: "P10" },
      { id: "11", displayText: "P11" },
      { id: "12", displayText: "P12" },
    ],
  },
  {
    key: "week",
    label: "Week",
    options: [
      { id: "1", displayText: "W1" },
      { id: "2", displayText: "W2" },
      { id: "3", displayText: "W3" },
      { id: "4", displayText: "W4" },
    ],
  },
  {
    key: "status",
    label: "Status",
    options: [
      { id: "0", displayText: "In-Progress" },
      { id: "1", displayText: "Completed" },
    ],
  },
  {
    key: "created/by",
    label: "Created By",
    options: [
      { id: "1", displayText: "Keerthi Velagala" },
      { id: "2", displayText: "Sohail Mohammed" },
      { id: "3", displayText: "Nuthi bhaskar" },
      { id: "4", displayText: "Vaibhav" },
    ],
  },
  {
    key: "finalized/by",
    label: "Finalized By",
    options: [
      { id: "1", displayText: "Keerthi Velagala" },
      { id: "2", displayText: "Sohail Mohammed" },
      { id: "3", displayText: "Nuthi bhaskar" },
      { id: "4", displayText: "Vaibhav" },
    ],
  },
  {
    key: "type/of/damage",
    label: "Type of Damage",
    options: [
      { id: "1", displayText: "Bent Frame" },
      { id: "2", displayText: "Missing Bolt" },
      { id: "3", displayText: "Severe Impact" },
      { id: "4", displayText: "Other" },
    ],
  },
];

/**
 * Filter options for Racking Inspection Begin screen
 */
export const RACKING_INSPECTION_FILTER_OPTIONS: FilterItem[] = [
  /* Period/Week filter removed */
  // {
  //   key: "aisle",
  //   label: "Aisle",
  //   options: [
  //     { id: "1", displayText: "A1" },
  //     { id: "2", displayText: "A2" },
  //     { id: "3", displayText: "A3" },
  //     { id: "4", displayText: "A4" },
  //     { id: "5", displayText: "A5" },
  //   ],
  // },
  // {
  //   key: "bay",
  //   label: "Bay",
  //   options: [
  //     { id: "1", displayText: "B1" },
  //     { id: "2", displayText: "B2" },
  //     { id: "3", displayText: "B3" },
  //     { id: "4", displayText: "B4" },
  //     { id: "5", displayText: "B5" },
  //   ],
  // },
  // {
  //   key: "level",
  //   label: "Level",
  //   options: [
  //     { id: "1", displayText: "L1" },
  //     { id: "2", displayText: "L2" },
  //     { id: "3", displayText: "L3" },
  //     { id: "4", displayText: "L4" },
  //     { id: "5", displayText: "L5" },
  //   ],
  // },
];

/**
 * Filter options for Damage Checklist tab
 */
export const DAMAGE_CHECKLIST_FILTER_OPTIONS: FilterItem[] = [
  {
    key: "aisle",
    label: "Aisle",
    options: [
      { id: "1", displayText: "1" },
      { id: "2", displayText: "2" },
      { id: "3", displayText: "3" },
      { id: "4", displayText: "4" },
    ],
  },
  {
    key: "bay",
    label: "Bay",
    options: [
      { id: "1", displayText: "B01" },
      { id: "2", displayText: "B02" },
      { id: "3", displayText: "B03" },
      { id: "4", displayText: "B04" },
    ],
  },
  {
    key: "level",
    label: "Level",
    options: [
      { id: "1", displayText: "L1" },
      { id: "2", displayText: "L2" },
      { id: "3", displayText: "L3" },
      { id: "4", displayText: "L4" },
    ],
  },
  {
    key: "period",
    label: "Period",
    options: [
      { id: "1", displayText: "P1" },
      { id: "2", displayText: "P2" },
      { id: "3", displayText: "P3" },
      { id: "4", displayText: "P4" },
    ],
  },
  {
    key: "week",
    label: "Week",
    options: [
      { id: "1", displayText: "W1" },
      { id: "2", displayText: "W2" },
      { id: "3", displayText: "W3" },
      { id: "4", displayText: "W4" },
    ],
  },
  {
    key: "type of damage",
    label: "Type of Damage",
    options: [
      { id: "1", displayText: "Bent Frame" },
      { id: "2", displayText: "Missing Bolt" },
      { id: "3", displayText: "Severe Impact" },
      { id: "4", displayText: "Other" },
    ],
  },
  {
    key: "status",
    label: "Status",
    options: [
      { id: "1", displayText: "Active" },
      { id: "2", displayText: "Completed" },
    ],
  },
  {
    key: "created by",
    label: "Created By",
    options: [
      { id: "1", displayText: "Keerthi Velagala" },
      { id: "2", displayText: "Sohail Mohammed" },
      { id: "3", displayText: "Nuthi bhaskar" },
      { id: "4", displayText: "Vaibhav" },
    ],
  },
  {
    key: "severity",
    label: "Severity",
    options: [
      { id: "1", displayText: "Low" },
      { id: "2", displayText: "Medium" },
      { id: "3", displayText: "High" },
      { id: "4", displayText: "Critical" },
    ],
  },
];

/**
 * Table columns for Walk Observations tab
 */
// export const WALK_OBSERVATIONS_TABLE_COLUMNS = [
//   { columnKey: "status", header: "Status" },
//   { columnKey: "periodweek", header: "Period Week" },
//   { columnKey: "totalregissues", header: "Total. Reg Issues" },
//   {
//     columnKey: "totalloadcapacityissues",
//     header: "Total. Load Capacity issues",
//   },
//   { columnKey: "totaldamageissues", header: "Total. Damage issues" },
//   { columnKey: "Typeofdamage", header: "Type of Damage" },
//   { columnKey: "walkprefdate", header: "Walk pref.Date" },
//   { columnKey: "walkstartedby", header: "Created By" },
//   { columnKey: "lastmodby", header: "Finalized By" },
// ];

export const WALK_OBSERVATIONS_TABLE_COLUMNS = [
  { columnKey: "status", header: "Status" },
  { columnKey: "periodweek", header: "Period Week" },
  { columnKey: "walkprefdate", header: "Created Time" },
  { columnKey: "walkstartedby", header: "Created By" },
  { columnKey: "Typeofdamage", header: "Type of Damage" },
  { columnKey: "totalregissues", header: "Total. Reg Issues" },
  {
    columnKey: "totalloadcapacityissues",
    header: "Total. Load Capacity issues",
  },
  { columnKey: "totaldamageissues", header: "Total. Damage issues" },
  { columnKey: "lastmodby", header: "Finalized By" },
  { columnKey: "lastmodtime", header: "Finalized Time" },
];
/**
 * Table columns for Damage Checklist tab
 */
export const DAMAGE_CHECKLIST_TABLE_COLUMNS = [
  { columnKey: "aisle", header: "AISLE" },
  { columnKey: "bay", header: "BAY" },
  { columnKey: "level", header: "LEVEL" },
  {
    columnKey: "slotid",
    header: "SLOT ID",
  },
  { columnKey: "typeofdamage", header: "TYPE OF DAMAGE" },
  { columnKey: "noofinst", header: "NO. OF INST." },
  { columnKey: "severity", header: "SEVERITY" },
  { columnKey: "obsrecdate", header: "Created Date" },
  { columnKey: "tgtdtofrep", header: "Target Date" },
  { columnKey: "actdtofrep", header: "Completion Date" },
  { columnKey: "periodWeek", header: "Period Week" },
  // NOTE: Do NOT use JSX or require in a .ts file. Use only plain column definition here.
  {
    columnKey: "status",
    header: "STATUS",
    // The renderCell should be injected at the point of use in a .tsx file, not here.
  },
  { columnKey: "comments", header: "COMMENTS" },
];

/**
 * Mock data for Walk Observations
 * TODO: Replace with actual API data
 */
export const MOCK_WALK_OBSERVATIONS_DATA = [
  {
    observations: "",
    assessorssignature: ".",
    miscellaneousObservations: "",
    status: "active",
    periodweek: "P1W2",
    totalregissues: 3,
    totalloadcapacityissues: 2,
    totaldamageissues: 1,
    Typeofdamage: "Minor",
    walkprefdate: "2023-06-15",
    walkstartedby: "John Doe",
    lastmodby: "Jane Smith",
  },
];

/**
 * Mock data for Damage Checklist
 * TODO: Replace with actual API data
 */
export const MOCK_DAMAGE_CHECKLIST_DATA = [
  {
    observations: "",
    assessorssignature: ".",
    status: "active",
    aisle: "A1",
    bay: "B2",
    level: "L3",
    slotid: "S123",
    typeofdamage: "Dent",
    noofinst: 2,
    severity: "Medium",
    obsrecdate: "2023-06-15",
    tgtdtofrep: "2023-07-15",
    actdtofrep: "",
    comments: "Needs attention",
  },
];

/**
 * Tabs configuration for Racking Inspection
 */
export const RACKING_INSPECTION_TABS = [
  {
    id: "walk-observations",
    title: "Walk Observations",
    icon: "directions-walk",
  },
  {
    id: "damage-checklist",
    title: "Damage Checklist",
    icon: "report-problem",
  },
];

/**
 * Severity levels for reference table
 */
export const SEVERITY_LEVELS = [
  {
    title: "Low Risk",
    description:
      "Presents a low-risk hazard. No attention needed at this time, watch.",
  },
  {
    title: "Medium Risk",
    description:
      "Presents a moderate risk hazard. Address in a timely manner, <12 months.",
  },
  {
    title: "High Risk",
    description:
      "Presents a high-risk hazard. Issue to be addressed immediately, discontinue use until hazard is repaired.",
  },
];

/**
 * Fields to exclude from detail view overlay
 */
export const DETAIL_VIEW_EXCLUDED_FIELDS = [
  "zone",
  "created",
  "by",
  "action",
  "status",
  "id",
  "rawData",
  "columnKey",
];
